export function isStringBooleanValue(
    value: string | null | undefined
): boolean {
    if (!value) {
        return false;
    }
    const lowercaseValue = value.toLowerCase().trim();
    return lowercaseValue === 'true' || lowercaseValue === 'false';
}
